'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#0A17A7" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.6667 6.6667C20.2985 6.6667 20 6.36823 20 6.00004C20 5.63185 20.2985 5.33337 20.6667 5.33337C21.0349 5.33337 21.3334 5.63185 21.3334 6.00004C21.3334 6.36823 21.0349 6.6667 20.6667 6.6667ZM20.6667 14.6667C20.2985 14.6667 20 14.3682 20 14C20 13.6318 20.2985 13.3333 20.6667 13.3333C21.0349 13.3333 21.3334 13.6318 21.3334 14C21.3334 14.3682 21.0349 14.6667 20.6667 14.6667ZM17.3334 10C17.3334 10.3682 17.0349 10.6667 16.6667 10.6667C16.2985 10.6667 16 10.3682 16 10C16 9.63185 16.2985 9.33337 16.6667 9.33337C17.0349 9.33337 17.3334 9.63185 17.3334 10ZM25.3334 10C25.3334 10.3682 25.0349 10.6667 24.6667 10.6667C24.2985 10.6667 24 10.3682 24 10C24 9.63185 24.2985 9.33337 24.6667 9.33337C25.0349 9.33337 25.3334 9.63185 25.3334 10ZM18.3097 12.357C18.57 12.6174 18.57 13.0395 18.3097 13.2998C18.0493 13.5602 17.6272 13.5602 17.3669 13.2998C17.1065 13.0395 17.1065 12.6174 17.3669 12.357C17.6272 12.0967 18.0493 12.0967 18.3097 12.357ZM23.9665 6.7002C24.2269 6.96055 24.2269 7.38266 23.9665 7.64301C23.7062 7.90336 23.2841 7.90336 23.0237 7.64301C22.7634 7.38266 22.7634 6.96055 23.0237 6.7002C23.2841 6.43985 23.7062 6.43985 23.9665 6.7002ZM23.0237 12.357C23.2841 12.0967 23.7062 12.0967 23.9665 12.357C24.2269 12.6174 24.2269 13.0395 23.9665 13.2998C23.7062 13.5602 23.2841 13.5602 23.0237 13.2998C22.7634 13.0395 22.7634 12.6174 23.0237 12.357ZM17.3669 6.7002C17.6272 6.43985 18.0493 6.43985 18.3097 6.7002C18.57 6.96055 18.57 7.38266 18.3097 7.64301C18.0493 7.90336 17.6272 7.90336 17.3669 7.64301C17.1065 7.38266 17.1065 6.96055 17.3669 6.7002Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagCkAsset = forwardRef(FlagCkAsset);

export { VpFlagCkAsset as default };
